
import React, { useContext, useState, useEffect} from "react";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";
import { motion } from "framer-motion";

export default function ModifyProjectDeadline ({ projectID, projectDeadline, setIsModifyDeadline }) {

  const { API_URL } = useContext(UrlContext);
  const [newDeadline, setNewDeadline] = useState(projectDeadline?.slice(0, 10) || "");
	const [loading, setLoading] = useState(false);

  // Block body scroll when modal is open
  useEffect(() => {
    document.body.classList.add("overflow-hidden");
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, []);

  const updateProjectDeadline = async () => {
    setLoading(true);
    const requestBody = {
      projectID: projectID,
      deadline: newDeadline,
    };

    try {
      let modifiedUrl = 'update-project-deadline';
      const response = await fetch(`${API_URL}${modifiedUrl}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      const responseData = await response.json();
      if (responseData.status === "success") {
        window.location.reload();
      } else {
        console.error("failed to update project deadline");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        transition={{ duration: 0.3 }}
        className="bg-white shadow-xl w-full max-w-md flex flex-col overflow-hidden rounded-2xl"
      >
        {/* Header */}
        <div className="flex items-center justify-between bg-[#365561] px-4 py-3">
          <h2 className="text-white font-semibold text-lg">
            Deadline reached!
          </h2>
          <i
            className="fa-solid fa-xmark text-gray-200 hover:text-white cursor-pointer text-xl"
            onClick={() => setIsModifyDeadline(false)}
          />
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          {loading ? (
            <div className="flex flex-col items-center justify-center py-8">
              <i className="fa-solid fa-spinner fa-spin text-4xl text-[#365561] mb-3"></i>
              <p className="text-gray-600">Updating deadline...</p>
            </div>
          ) : (
            <>
              <label className="block text-gray-700 font-medium">
                Extend project deadine to send invites!
              </label>
              <input
                type="date"
                value={newDeadline}
                onChange={(e) => setNewDeadline(e.target.value)}
                className="w-full border rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                required
              />

              <div className="flex justify-end space-x-3 pt-4">
                <button
                  type="button"
                  className="px-4 py-2 rounded-lg bg-gray-300 text-gray-800 hover:bg-gray-400"
                  onClick={() => setIsModifyDeadline(false)}
                >
                  Cancel
                </button>
                <button
                  onClick={updateProjectDeadline}
                  className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
                >
                  Save
                </button>
              </div>
            </>
          )}
        </div>
      </motion.div>
    </div>
  );
}